<template>
  <div class="w-full" v-if="isVisible">
    <div class="
        overflow-x-hidden overflow-y-auto
        fixed
        inset-0
        z-50
        outline-none
        focus:outline-none
        bg-black bg-opacity-70
      ">
      <div class="
          justify-center
          items-center
          flex
          my-8
          mx-auto
          w-auto
          xl:max-w-[500px]
        " style="min-height: calc(100% - 3.5rem)">
        <div class="w-full">
          <!--content-->
          <div class="
              shadow-lg
              relative
              flex flex-col
              w-full
              bg-white
              outline-none
              focus:outline-none
              border-black border-4 border-solid rounded-2xl p-8
            ">
            <!--header-->
            <div class="
                flex
                items-start
                justify-between
              ">
              <h3 class="heading-color xl:text-3xl font-bold text-3xl capitalize">
                Specify Shared Tag
              </h3>
              <button class="
                  rounded-full
                  menu1-background-color
                  flex
                  items-center
                  justify-center
                  p-1
                  ml-auto
                  bg-transparent
                  border-0
                  text-white
                  opacity-1
                  float-right
                  text-xl
                  leading-none
                  font-semibold
                  outline-none
                  focus:outline-none
                " @click="closeModal">
                <span class="
                    flex
                    items-center
                    justify-center
                    bg-transparent
                    text-white
                    opacity-100
                    h-5
                    w-5
                    text-2xl
                    block
                    outline-none
                    focus:outline-none
                  ">
                  ×
                </span>
              </button>


            </div>
            <!--body-->
            <div class="relative pt-6 flex-auto">

              <div class="relative flex justify-between">
                <div class="relative w-full max-w-[500px]">
                  <input
                    class=" w-full shadow-sm focus:border-none block sm:text-base border-gray-300 rounded-lg h-12 input-background"
                    type="text" id="mc_option_recipe_search" v-model="tag" @input="
                      searchTag(
                        $event
                      )
                      " placeholder="Create or choose an existing tag" maxlength="50" />
                  <div class="
                        absolute
                        bg-white
                        max-w-2xl
                        overflow-x-auto
                        w-full
                        max-h-150
                      ">
                    <div v-for="searched_recipe in searched_tags" class="py-1 px-3 cursor-pointer hover:bg-gray-100"
                      @click="selectTagToAdd(searched_recipe)">
                      {{ searched_recipe.name
                      }}
                    </div>
                  </div>
                </div>
                <!-- <div class="ml-3 w-20 min-w-20 flex items-center justify-center">
                  <input type="color"
                    class="pr-[3px] pl-[3.5px] py-[2px] w-full shadow-sm focus:border-none border-none block sm:text-base rounded-lg h-12 bg-[#39b54a] p-0"
                    v-model="color">
                </div> -->

              </div>

              <div class="mt-4 max-w-[336px]" v-if="existTag && existTag.length"> 
                  <draggable class="flex flex-col gap-2 divide-y divide-gray-300" tag="ul" v-model="existTag" item-key="id"  @change="event => handleDrag(event)">
                <template #item="{ element, index }">
                    <li  class="draggable-item cursor-move w-full">
                      <div class="flex gap-2 items-center w-full">
                      <!-- <span class="uppercase">{{ getName(index) }} </span> -->
                      <span class="uppercase">{{ element.name }}</span>
                      <div class="ml-auto flex gap-2 items-center">
                      <span :style="{'background-color': getColor(index)}" class="w-8 h-5 inline-flex"></span>                      
                      <a class="font-bold text-color-first-li" href="javascript:void(0)" @click="selectUseTag(element)">use</a> 

                      <a class="font-bold text-red-500" href="javascript:void(0)" @click="removeTag(element)">X</a> 
                      </div>
                    </div>                      
                    </li>
                </template>
              </draggable>
              <!-- <ul class="flex flex-col gap-2 divide-y divide-gray-300">
                  <li v-for="eTag in existTags">
                    <div class="flex gap-2 items-center w-full">
                      <span class="uppercase">{{ eTag.name }}</span>
                      <div class="ml-auto flex gap-2 items-center">
                      <span :style="{'background-color': eTag.color}" class="w-8 h-5 inline-flex"></span>                      
                      <a class="font-bold text-color-first-li" href="javascript:void(0)" @click="selectUseTag(eTag)">use</a>
                      </div>
                    </div>
                  </li>
                </ul> -->
              </div>

              


              <div class="mt-4">

                <div class="mt-4 flex
                items-center
                justify-end">
                  <span class="
                  text-white
                  bg-[#39b54a]
                  hover:bg-[#39b54a] hover:text-white
                  active:bg-[#39b54a]
                  font-bold
                  uppercase
                  md:w-24 text-center
                  text-base
                  px-6
                  py-3
                  rounded
                  outline-none
                  focus:outline-none
                  ease-linear
                  transition-all
                  duration-150 cursor-pointer mt-5" v-if="tag && tag != ''" @click="attachTag()">Save</span>
                </div>

              </div>
            </div>

            <!--footer-->

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { Inertia } from "@inertiajs/inertia";
import vClickOutside from "click-outside-vue3";
import draggable from "vuedraggable";

export default {
  props: [
    'isOpenTagModel', 'existTags', 'shared_letters'
  ],

  directives: {
    clickOutside: vClickOutside.directive,
  },

  components: {
    draggable
  },
  name: "large-modal",
  data() {
    return {
      // isVisible: this.isOpenTagModel,
      isVisible: true,
      tag_id: null,
      tag: null,
      color: '#ffffff',
      searched_tags: [],
      default_color: '#ffffff',
      existTag: this.existTags,
      list: [
        { name: "John", id: 0 },
        { name: "Joao", id: 1 },
        { name: "Jean", id: 2 }
      ],
      dragging: false,
    }

  },

  methods: {
    closeModal() {
      // this.isVisible = false;
      this.tag = this.tag_id = null;
      this.color = this.default_color;
      this.searched_tags = [];
      this.$emit('closeTagPopup');
    },
    selectTagToAdd(tag) {
      this.tag = tag.name;
      this.color = tag.color;
      this.tag_id = tag.id;
      this.searched_tags = [];
    },

    selectUseTag(tag) {
      this.tag = tag.name;
      this.color = tag.color;
      this.tag_id = tag.id;
      this.attachTag();
    },

    attachTag() {
    if(this.tag && this.tag != ''){
      axios
            .post("/tags/upsert", { name: this.tag, color: this.color })
            .then((response) => {
            })
            .catch((error) => console.error(error));
      this.$emit('attachTag', { name: this.tag, color: this.color, id: this.tag_id });
      this.tag = this.tag_id = null;
      this.color = this.default_color;
    }
      
    },
    searchTag(e) {
      let $this = this;
      let search_term = e.target.value;
      this.$toast.clear();
      clearTimeout(this.debounce)
      if (search_term == "") {
        this.searched_tags = [];
        this.$toast.error("Error: Search value required!");
      } else {
        this.debounce = setTimeout(() => {
          axios
            .post("/tags", {
              search: search_term
            })
            .then((response) => {
              $this.searched_tags = [];
              if (response.data.status) {
                $this.searched_tags = response.data.data;
              }
            })
            .catch((error) => console.error(error));
        }, 900);
      }
    },

    getColor(index) {
      let dColor = '#ffffff';
      if (index === -1) return dColor;
        // Convert index to alphabet: 0 -> A, 1 -> B, etc.
        const letter = String.fromCharCode(65 + index)
      return this.shared_letters[letter] || dColor;
    },

    getName(index) {
      let dColor = '#ffffff';
      if (index === -1) return dColor;
        // Convert index to alphabet: 0 -> A, 1 -> B, etc.
        const letter = String.fromCharCode(65 + index)
      return letter || dColor;
    },
    handleDrag(event) {
      console.log(this.existTag);
      this.$emit('handleTagSortable', this.existTag);
    },
    removeTag(tag) {
      if(confirm('Are you sure you want to remove this tag?')){
        this.$emit('removeDayTag', tag);
        
        this.existTag = JSON.parse(JSON.stringify(this.existTag.filter((item) => item.name !== tag.name)));
      }
      },
  },
};
</script>

<style>
.searching-background-color {
  background-color: #38558e;
}

.button-bg-color-wed-menu2-gray {
  border: none !important;
  min-height: 35px;
  min-width: 35px;
}

.button-bg-color-wed-menu2 {
  background-color: #38558e;
  border: none !important;
  min-height: 35px;
  min-width: 35px;
}

.menu1-icon-color {
  color: #38558e;
}

.cancel-background-color {
  background-color: #8b8b8b;
}

.placeholder-background-color {
  background-color: #f8f8f8;
}

.mt-0-down {
  margin-top: -54px;
}

.button-bg-color-wed-menu1 {
  background-color: #cbcbcb45;
}

.text-color-first-li {
  color: #38558e;
}

.icon-star-color {
  color: #f7a53a;
}

.th-heading-background {
  background-color: #f4f4f4;
}

.button-bg-color-wed {
  background-color: #cbcbcb;
}

.input-background {
  background-color: #f8f8f8;
}

.white-shadow-box {
  box-shadow: 0px 2px 5px #0000005e;
}

.bg-button-color {
  background-color: #cb0000;
}

.min-w-min-button {
  min-height: 26px;
  min-width: 53px;
}

.max-w-0-menu1 {
  max-width: 4rem;
}

.bg-button-color-green {
  background-color: #22af4b;
}

.bg-button-color-gray {
  background-color: #636363;
}

.bg-hard-grey {
  background-color: #f4f4f4;
}

.min-w-min-button-menu1 {
  min-height: 27px;
  min-width: 26px;
  border: 1px solid lightgrey;
}

#inputUpload {
  display: none;
}

.custom-file-upload {
  cursor: pointer;
  font-size: inherit;
  color: #0c090d;
}

.min-h-full-menu1 {
  min-height: 200px;
}

.custom-file-upload:hover {
  text-decoration: underline;
}

.border-property {
  border: 1px solid gray;
  margin-top: 20px;
  border-style: dashed;
  border-bottom: none;
}

.menu1-background-color {
  background-color: #faa43d;
}

.menu1-text-color {
  color: #faa43d;
}

.min-height-third {
  min-height: 400px;
}

.select-menu-height {
  height: 100%;
}

.min-height-fivth {
  min-height: 70px;
}

.icon-position-menu1 {
  position: absolute;
  top: -5px;
  right: 41px;
}

.icon-position-menu2 {
  position: absolute;
  top: -5px;
  right: -3px;
}

.position-cross {
  position: absolute;
  right: -21px;
  top: -25px;
  z-index: 1;
  overflow: auto;
}

/* .w-4/12-h2 {
  width: 29%;
} */

.pt-2-space {
  padding-top: 5px;
}

.-top-px {
  top: -4px;
}

.max-h-650 {
  max-height: 650px;
}

.max-h-150 {
  max-height: 150px;
}

.expand_recipe {
  transform: rotate(180deg);
}

.loader-15 {
  background: currentcolor;
  position: relative;
  animation: loader-15 1s ease-in-out infinite;
  animation-delay: 0.4s;
  width: 0.25em;
  height: 0.5em;
  margin: 37px auto;
}

.loader-15:after,
.loader-15:before {
  content: "";
  position: absolute;
  width: inherit;
  height: inherit;
  background: inherit;
  animation: inherit;
}

.loader-15:before {
  right: 0.5em;
  animation-delay: 0.2s;
}

.loader-15:after {
  left: 0.5em;
  animation-delay: 0.6s;
}

@keyframes loader-15 {

  0%,
  100% {
    box-shadow: 0 0 0 currentcolor, 0 0 0 currentcolor;
  }

  50% {
    box-shadow: 0 -0.25em 0 currentcolor, 0 0.25em 0 currentcolor;
  }
}
</style>
